/**
 * @file 用户个人中心帖子列表
 * @author Ray 2026-01-30
 */

import { Toast } from "@/components";
import request, { MethodEnum, serverTriggerUrl } from "@/utils/fetch";
import { IThreadLisItem } from "@/api/thread/list";
import { formatArticalCovers } from "@/hooks/useFormatArticalContent";

export enum USER_CENTER_THREAD_TYPE {
  MY_POSTS = 1,
  FAVORITE = 2,
  LIKED = 3,
}

export interface IUserCenterThreadsReq {
  uid: number;
  type?: USER_CENTER_THREAD_TYPE;
  page?: number;
  page_size?: number;
}

const normalizeThreads = (items: IThreadLisItem[] = []) =>
  items.map((item) => {
    const covers = Array.isArray((item as any).covers) ? (item as any).covers : [];
    const formattedCovers = formatArticalCovers(covers);
    return {
      ...item,
      covers: formattedCovers,
    };
  });

export interface IUserCenterThreadsRes {
  items: IThreadLisItem[];
  total?: number;
}

export const getUserCenterThreads = (
  params: IUserCenterThreadsReq,
  isServerTrigger = false,
  headers = {}
): Promise<IUserCenterThreadsRes> => {
  const { uid, type, page = 1, page_size = 10 } = params;
  const key = "GetUserCenterThreads";
  const prefix = isServerTrigger ? serverTriggerUrl : "";

  return request({
    url: `${prefix}/forum/thread/user/${uid}`,
    method: MethodEnum.GET,
    key,
    isServerTrigger,
    headers,
    params: {
      type,
      page,
      page_size,
    },
  })
    .then((data: any) => {
      const itemBlock = data?.item || data?.items || data;
      const list = Array.isArray(itemBlock?.list)
        ? itemBlock.list
        : Array.isArray(itemBlock)
        ? itemBlock
        : [];
      const total =
        typeof itemBlock?.total === "number" ? itemBlock.total : undefined;
      return {
        items: normalizeThreads(list),
        total,
      };
    })
    .catch((err) => {
      if (!isServerTrigger) {
        Toast.show({
          content: err.message,
        });
      }
      return Promise.reject(err);
    });
};

export default getUserCenterThreads;
